import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';

export const buildTileStyle = (tileColor: string) => css`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: none;
	width: 2.75rem;
	height: 2.75rem;
	border-radius: ${theme.radii.small};
	background-color: ${tileColor};
	color: ${theme.colors.surface};
`;

export default buildTileStyle;
